module.exports = "/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n.red{\n  color:red\n}\n.green{\n  color:green\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/tradereport/tradereport.component.css
// module id = ./src/app/tradereport/tradereport.component.css
// module chunks = main